import "../styles/nav-icon.css";
export default function CustomNavIcon({ label }) {
  const expandIcon = (e) => {
    e.target.classList.toggle("on", true);
  };

  const resetIcon = (e) => {
    e.target.classList.toggle("on", false);
  };
  let labelIcon = "";

  switch (label) {
    case "Home":
      labelIcon = "10";
      break;
    case "About":
      labelIcon = "41";
      break;
    case "FAQ":
      labelIcon = "17";
      break;
    case "Contact":
      labelIcon = "16";
      break;
    default:
      labelIcon = "00";
      break;
  }

  return (
    <div
      className="icon-wrapper"
      id={`${label}-icon`}
      onMouseEnter={expandIcon}
      onMouseLeave={resetIcon}
    >
      <div className="icon">
        <img
          width={30}
          height={30}
          sizes="(max-width: 30px) 30px, 30px"
          alt={label}
          src={`/images/${labelIcon}.webp`}
        ></img>
      </div>
      {/* <span aria-hidden="true" id='mute-icon'>{labelIcon}</span> */}

      <p htmlFor={label} className="label">
        {label}
      </p>
    </div>
  );
}
